import { Box, DropdownButtonContext } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useCallback, useContext } from 'react';

import { ConversationContext } from 'components/conversation';
import { CopilotDropdownActionContext } from 'components/copilotDropdown';
import { CopilotDropdownHeader } from 'components/copilotDropdown/components/header';
import {
  OnLanguageChangeEvent,
  TranslateTextLanguageSelectionList,
} from 'components/translateTextLanguageSelectionList';

export const ConversationCopilotDropdownTranslate = (): JSX.Element | null => {
  const { onBack, actionsComputed } = useContext(CopilotDropdownActionContext);
  const actionComputed = actionsComputed.translate;
  const { closeDropdown, dropdownOpen } = useContext(DropdownButtonContext);
  const { setTranslationLanguageCode, translationLanguageCode } =
    useContext(ConversationContext);

  const handleLanguageChange = useCallback(
    (event: OnLanguageChangeEvent): void => {
      closeDropdown();

      if (event.selectedLanguage) {
        ampli.agentCopilotTranslateMessageLanguageSelected({
          language: event.selectedLanguage.name,
          context: 'allMessages',
        });
        setTranslationLanguageCode?.(event.selectedLanguage.code);
      }
    },
    [closeDropdown, setTranslationLanguageCode],
  );

  const handleRevert = useCallback(() => {
    closeDropdown();
    setTranslationLanguageCode?.(undefined);
  }, [closeDropdown, setTranslationLanguageCode]);

  return (
    <Box>
      <CopilotDropdownHeader title={actionComputed.title} onBack={onBack} />

      <TranslateTextLanguageSelectionList
        autoFocusSearch={dropdownOpen}
        selectedLanguageCode={translationLanguageCode}
        onRevert={handleRevert}
        onLanguageChange={handleLanguageChange}
      />
    </Box>
  );
};
